import { Type } from 'class-transformer';

export class CommunityPropertiesResultDto {
    accountNumber: string;
    ownerFirstLastName: string;
    ownerLastFirstName: string;
    combinedOwner: string;
    ownerType: string;
    propertyAddress: string;
    propertyCSZ: string;
    phase: string;
    section: string;
    lot: string;
    block: string;
    ownerOccupied: string;
    @Type(() => Date)
    assessmentStartDate: Date;
    @Type(() => Date)
    buyerCloseDate: Date;
    cell: string;
    community: string;
    currentOwner: string;
    drvCollections: string;
    email1: string;
    email2: string;
    hasTenant: string;
    inBankruptcy: boolean;
    inCollections: boolean;
    inForeclosure: boolean;
    legalUnitNumber: string;
    location: string;
    lotType: string;
    mailingAddress: string;
    mailingAddress2: string;
    mailingCity: string;
    mailingCountry: string;
    mailingState: string;
    mailingZip: string;
    phone: string;
    priorId: string;
    propertyType: string;
    locationId: number;
    communityId: number;
    ownerId: number;
    propertyId: number;
    sectionId: number;
    lotTypeCode: string;
    communityCode: string;
    compositeKey: string;
    streetName: string;
    streetNumber: string;
}
